import { render } from "./Project2View.vue?vue&type=template&id=714d407b&scoped=true&ts=true"
import script from "./Project2View.vue?vue&type=script&lang=ts"
export * from "./Project2View.vue?vue&type=script&lang=ts"

import "./Project2View.vue?vue&type=style&index=0&id=714d407b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714d407b"]])

export default __exports__